import { LanguageService, BaseSiteService } from '@spartacus/core';
import { TranslateService } from '@ngx-translate/core';
import { first, switchMap, tap } from 'rxjs';
import { inject } from '@angular/core';

/**
 * APP INITIALIZER: init site locale
 * @returns An observable, no usefull value
 */
export const appInitLang = () => {
  const translateService = inject(TranslateService);
  const languageService = inject(LanguageService);

  return languageService.getActive().pipe(
    first((lang) => !!lang),
    switchMap((lang) => translateService.use(lang))
  );
};

/**
 * APP INITIALIZER: set default site locale
 * @returns An observable, no usefull value
 */
export const appInitDefaultLang = () => {
  const translateService = inject(TranslateService);
  const baseSiteService = inject(BaseSiteService);

  return baseSiteService.get().pipe(
    first((baseSite) => !!baseSite),
    tap((baseSite) => {
      translateService.setDefaultLang(baseSite.defaultLanguage.isocode);
    })
  );
};
